module.exports = __webpack_public_path__ + "static/lato 2024 - acro dance art & fun-bf01cf3b7d61252acb7fe2db401989a4.jpg";